import React from 'react';
import Overlay from './Overlay';
import { Button } from '@ui';
import { IconCloseX } from '@icons';

interface SlideOverProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  id?: string;
  actions?: React.ReactNode;
  className?: string;
}

export const SlideOver: React.FC<SlideOverProps> = ({
  open,
  onClose,
  title,
  children,
  id = 'modal-slideover',
  actions,
  className,
}) => (
  <Overlay
    open={open}
    onClose={onClose}
    id={id}
    ariaLabelledBy={`${id}-title`}
    asSlideOver
    className={className}
  >
    <aside className='slide-panel' role='document'>
      <header className='modal-header'>
        <h3 className='modal-title' id={`${id}-title`}>
          {title}
        </h3>
        <Button
          className='btn-close'
          aria-label='Close'
          onClick={onClose}
          as='button'
          type='button'
          icon={<IconCloseX />}
        />
      </header>
      <div className='modal-body'>{children}</div>
      {actions && <footer className='modal-footer'>{actions}</footer>}
    </aside>
  </Overlay>
);

export default SlideOver;
